var _style, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFrax = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 283.46 283.46",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0frax{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.73 283.46a141.38 141.38 0 0 1-100.22-41.51A141.27 141.27 0 0 1 0 141.73 141.38 141.38 0 0 1 41.51 41.51 141.38 141.38 0 0 1 141.73 0a141.38 141.38 0 0 1 100.22 41.51 141.27 141.27 0 0 1 41.51 100.22 141.38 141.38 0 0 1-41.51 100.22 141.27 141.27 0 0 1-100.22 41.51z",
    className: "st0frax"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.73,
    cy: 141.73,
    r: 134.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.43 141.73a70.31 70.31 0 0 0-11.72-38.94l21.95-21.95-19.74-19.74-21.89 21.89a70.24 70.24 0 0 0-39.29-11.96 70.31 70.31 0 0 0-38.94 11.72L80.84 60.8 61.1 80.54l21.89 21.89a70.24 70.24 0 0 0-11.96 39.29 70.31 70.31 0 0 0 11.72 38.94L60.8 202.62l19.74 19.74 21.89-21.89a70.24 70.24 0 0 0 39.29 11.96 70.31 70.31 0 0 0 38.94-11.72l21.96 21.96 19.74-19.74-21.89-21.89a70.36 70.36 0 0 0 11.96-39.31zm-113.47 0c0-23.59 19.19-42.78 42.78-42.78s42.78 19.19 42.78 42.78-19.19 42.78-42.78 42.78-42.78-19.19-42.78-42.78z",
    className: "st0frax"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFrax);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/frax.80d93c20e9e5d52a72a0f6d7e44845d7.svg";